/* eslint-disable */

/**
 * Type library as nested object
 * This avoids the verbose version of type definition in js.
 * This library is to resemble TypeScript typed syntax.
 * This will allow interface and type declarations to migrate easily with to Typescript
 * jsDoc typedef syntax can be written completely in ts.
 * @file deines typee-safe library in javascript
 *
 * TODO organize by component
 *
 * Refer to docs for how ot import types
 * @link https://dev.to/t7yang/type-safety-in-javascript-with-jsdoc-and-vscode-1a28
 * Refer to link on how to enble intellisense
 * @link https://www.blinkingcaret.com/2020/10/07/javascript-intellisense/
 * JSdoc proerty overview
 * @link https://usejsdoc.org/tags-property.html#overview
 *
 * @example
 * TypeScript
 * interface IUserProps {
 *   name: string;
 *   age: number;
 *   email: string;
 * }
 *
 * @example
 * Verbose JsDoc
 * @typedef {Object} IUserProps
 * @property {string} name
 * @property {number} age
 * @property {string} email
 *
 * @example
 * Nested JSDo
 * @typedef {{
 *   name: string;
 *   age: number;
 *   email: string;
 * }} IUserProps
 *
 */


// TODO continue adding types here as needed

/**
 * Landing Categories
 * @typedef {{
    acadLink: string,
    name: number,
    icon: string,
    children: {
      name: string,
      children: SubCategory[]
    }[],
    presales: string,
    slug: string,
    val: string,
  }} LandingCategories
 */

/**
 * SubCategory
 * @typedef {{
    academyCategoryFk: number, 
    outputOrder: number, 
    phoneFk: number, 
    pk: number, 
    presales: string, 
    slug: string, 
    val: string, 
  }} SubCategory
 */

/**
 * Current Device
 * @typedef {{
    id: number, 
    customerID?: string,
    image_location: string, 
    manufacturer: string, 
    name: string | null, 
    name_pretty: string, 
    os: string | null, 
    slug: string, 
    vanity_name: string | null
  }} Device
 */

/**
 * Location Object
 * @typedef {{
    action: string, 
    hash: string, 
    key: string | null, 
    pathname: string, 
    query: {}, 
    search: string | null, 
    slug: string, 
    state: {} | undefined
  }} Location
 */

/**
 * Modules Available
 * @typedef {{
   tutorials: boolean, 
   faqs: boolean, 
   guides: boolean, 
   videos: boolean
  }} ModulesAvailable
 */

/**
 * Top Links
 * @typedef {{ 
   show: boolean, 
   text: string | null
   url: string
  }} TopLinks
 */

/**
 * Header
 * @typedef {{ 
   ':type': string
   brandName?: string
   cartIconUrl: string
   countOfTopKeywords: string
   doNotFollow: string
   durationInDays: string
   fileReference: string
   fileReferenceDeskSm: string
   fileReferenceMobile: string
   items: {
     navigation: NavigationObject
     languagenavigation: {
       ':type': string
       items: Array<NavigationItem>
     }
     locationservices: LocationServicesObject
     multilinks: {
       ':type': string
     }
   }
   links: Array<LinkItem>
   logoAltTextDesktop: string
   logoAltTextMobile: string
   logoNewWindow: string
   logoRedirectionMessage: string
   logoTargetURL: string
   rootBrandFolder: string
   searchAutoCompleteApiDomain: string
   searchAutoCompleteApiEngineId: string
   searchAutoCompleteApiPath: string
   searchIconUrl: string
   typeaheadMaxCount: string
   
  }} Header
 */

/**
 * Navigation Object
 * @typedef {{ 
   ':type': string
   accessibilityLabel: string
   item: Array<{
     active: boolean
     children: Array<{
       active: boolean
       children: Array<{
         active: boolean
         children: Array<NavigationItem>
       }>
     }>
   }>
  }} NavigationObject
 */

/**
 * Location Services Object
 * @typedef {{ 
   ':type': string
   apiDomain: string
   apiKey: string
   cookieTimeout: number
   doNotFollow: string
   errormsg: string
   locationdesc: string
   locationlabel: string
   locationtext: string
   path: string
   reversePath: string
  }} LocationServicesObject
 */

/**
 * Navigation Item
 * @typedef {{ 
   active: boolean 
   children: array
   description: string
   lastModified: number
   level: number
   path: string
   title: string
   url: string
   locale: string | null
   country: string | null
  }} NavigationItem
 */

/**
 * Link Item
 * @typedef {{ 
   ctaType?: string | null,
   doNotFollowLink: string
   eventName?: string | null
   heading: string | null
   linkAltText: string
   linkIcon: string | null
   linkText: string
   linkUrl: string
   newWindow: string | null
   showLinkText: boolean
  }} LinkItem
 */



// WEBPACK FOOTER //
// ./src/types/index.js